<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import validations, { getSharedFileNameErrorMessage } from './validations';
import { useVuelidate } from '@vuelidate/core';

import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  props: {
    selectedResponse: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['close'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      name: '',
    };
  },
  validations,
  computed: {
    ...mapGetters({
      uiFlags: 'sharedFiles/getUIFlags',
    }),
    pageTitle() {
      return `${this.$t('SHARED_FILE_MGMT.EDIT.TITLE')}: ${
        this.selectedResponse.name
      }`;
    },
    sharedFileNameErrorMessage() {
      const mappingErrorMessage = {
        REQUIRED_ERROR: this.$t('SHARED_FILE_MGMT.FORM.NAME.REQUIRED_ERROR'),
        VALID_ERROR: this.$t('SHARED_FILE_MGMT.FORM.NAME.VALID_ERROR'),
        LENGTH_ERROR: this.$t('SHARED_FILE_MGMT.FORM.NAME.LENGTH_ERROR'),
      };

      return mappingErrorMessage[getSharedFileNameErrorMessage(this.v$)];
    },
  },
  mounted() {
    this.setFormValues();
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    setFormValues() {
      this.name = this.selectedResponse.name;
    },
    editFile() {
      this.$store
        .dispatch('sharedFiles/update', {
          id: this.selectedResponse.id,
          name: this.name,
        })
        .then(() => {
          useAlert(this.$t('SHARED_FILE_MGMT.EDIT.API.SUCCESS_MESSAGE'));
          setTimeout(() => this.onClose(), 10);
        })
        .catch(() => {
          useAlert(this.$t('SHARED_FILE_MGMT.EDIT.API.ERROR_MESSAGE'));
        });
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header :header-title="pageTitle" />
    <form class="flex flex-wrap mx-0 w-full" @submit.prevent="editFile">
      <woot-input
        v-model="name"
        :class="{ error: v$.name.$error }"
        class="w-full"
        :label="$t('SHARED_FILE_MGMT.FORM.NAME.LABEL')"
        :placeholder="$t('SHARED_FILE_MGMT.FORM.NAME.PLACEHOLDER')"
        :error="sharedFileNameErrorMessage"
        @input="v$.name.$touch"
        @blur="v$.name.$touch"
      />
      <div class="flex items-center justify-end w-full gap-2 px-0 py-2">
        <NextButton
          faded
          slate
          type="reset"
          :label="$t('SHARED_FILE_MGMT.FORM.CANCEL')"
          @click.prevent="onClose"
        />
        <NextButton
          type="submit"
          :label="$t('SHARED_FILE_MGMT.FORM.EDIT')"
          :disabled="v$.name.$invalid || uiFlags.isUpdating"
          :is-loading="uiFlags.isUpdating"
        />
      </div>
    </form>
  </div>
</template>
